import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import CompareFiltersStandalone from '../../src/octochangelog/ror_components/CompareFiltersStandalone.tsx';

ReactOnRails.register({CompareFiltersStandalone});